import React, { useEffect, useContext } from 'react';
import { Routes, Route, Navigate, redirect, useLocation  } from "react-router-dom";

/** Component Pages Here */
import StoreSelector from '../components/pages/StoreSelector';
import ProfileContext from '../services/profileContext';

/**
 * Store Profile
 */
import StoreProfilePage from '../components/pages/store/StoreProfilePage';
import StoreDeliveryAddressPage from '../components/pages/store/StoreDeliveryAddressPage';
import StoreWarehousesPage from '../components/pages/store/StoreWarehousesPage';

import LoginPage from '../components/pages/LoginPage';
import Page404 from '../components/pages/Page404';
import DeniedPage from '../components/pages/DeniedPage';

import StarterTemplate from '../components/pages/StarterTemplate';

import ProfilePage from '../components/pages/account/ProfilePage';

import ProductList from '../components/pages/products/ProductList';
import ProductForm from '../components/pages/products/ProductForm';

import InventoryAdjustmentList from '../components/pages/products/InventoryAdjustmentList';
import InventoryAdjustmentForm from '../components/pages/products/InventoryAdjustmentForm';

import SalesOrderList from '../components/pages/sales-order/SalesOrderList';
//import SalesOrderForm from '../components/pages/sales-order/SalesOrderForm';
import SalesOrderView from '../components/pages/sales-order/SalesOrderView';
import SalesOrderForm from '../components/pages/sales-order/SalesOrderForm';
import SalesOrderPrintView from '../components/pages/sales-order/SalesOrderPrintView';

import SalesReturnList from '../components/pages/sales-order/SalesReturnList';
import SalesReturnForm from '../components/pages/sales-order/SalesReturnForm';

import InvoicesList from '../components/pages/invoices/InvoicesList';
import InvoiceForm from '../components/pages/invoices/InvoiceForm';
import InvoiceView from '../components/pages/invoices/InvoiceView';
import InvoicePrintView from '../components/pages/invoices/InvoicePrintView';

import PaymentReceiveList from '../components/pages/payment-received/PaymentReceiveList';
import PaymentReceiveForm from '../components/pages/payment-received/PaymentReceiveForm';

import PurchaseOrderList from '../components/pages/purchase-order/PurchaseOrderList';
import PurchaseOrderForm from '../components/pages/purchase-order/PurchaseOrderForm';
import PurchaseOrderPrintView from '../components/pages/purchase-order/PurchaseOrderPrintView';
import PurchaseOrderView from '../components/pages/purchase-order/PurchaseOrderView';

import PurchaseReceivesList from '../components/pages/purchase-order/PurchaseReceivesList';
import PurchaseReceiveForm from '../components/pages/purchase-order/PurchaseReceiveForm';

import BillsList from '../components/pages/bills/BillsList';
import BillForm from '../components/pages/bills/BillForm';
import BillView from '../components/pages/bills/BillView';
import BillPrintView from '../components/pages/bills/BillPrintView';

import PaymentMadeList from '../components/pages/payment-made/PaymentMadeList';
import PaymentMadeForm from '../components/pages/payment-made/PaymentMadeForm';

import BrandsList from '../components/pages/management/BrandsList';
import VariantTypesList from '../components/pages/products/VariantTypesList';
import CategoryList from '../components/pages/management/CategoryList';

import ShipmentsList from '../components/pages/sales-order/ShipmentList';
import ShipmentForm from '../components/pages/sales-order/ShipmentForm';

import ContactList from '../components/pages/management/ContactList';
import ContactForm from '../components/pages/management/ContactForm';

import VendorsList from '../components/pages/management/VendorsList';
import VendorsForm from '../components/pages/management/VendorsForm';

import CouriersList from '../components/pages/management/CouriersList';

import helpers from '../services/helpers';

/**
 * Reports
 */
import ReportListPage from '../components/pages/reports/ReportListPage';
import ReportInventory from '../components/pages/reports/ReportInventory';
import ReportSalesOrder from '../components/pages/reports/ReportSalesOrder';
import ReportInvoiceItem from '../components/pages/reports/ReportInvoiceItem';
import ReportInvoices from '../components/pages/reports/ReportInvoices';
import ReportPurchasesOrder from '../components/pages/reports/ReportPurchasesOrder';
import ReportPurchasesItem from '../components/pages/reports/ReportPurchasesItem';
import ReportBills from '../components/pages/reports/ReportBills';
import ReportContacts from '../components/pages/reports/ReportContacts';
import ReportVendors from '../components/pages/reports/ReportVendors';
import ReportPaymentReceived from '../components/pages/reports/ReportPaymentReceived';
import ReportPaymentMade from '../components/pages/reports/ReportPaymentMade';
import ReportSalesReturn from '../components/pages/reports/ReportSalesReturn';
/************************ */

/**
 * Settings
 */
import PageSettings from '../components/pages/management/PageSettings';
import TaxRatesList from '../components/pages/management/TaxRatesList';
import DiscountRatesList from '../components/pages/discount-rates/DiscountRatesList';

import UnderConstructionPage from '../components/pages/UnderConstructionPage';

/**
 * Accounting Module
 */
import ChartOfAccountsList from '../components/pages/accounting/ChartOfAccountsList';
import JournalsList from '../components/pages/accounting/JournalsList';
import SharesList from '../components/app/savers/SharesList';
import HomePageSavers from '../components/app/savers/HomePageSavers';
import SharesForm from '../components/app/savers/SharesForm';
import GroupForm from '../components/app/savers/GroupForm';
import ProductUnitList from '../components/pages/service-hub/ProductUnitList';
import ProductUnitForm from '../components/pages/service-hub/ProductUnitForm';
import ServiceRequestList from '../components/pages/service-hub/ServiceRequestList';
import ServiceRequestForm from '../components/pages/service-hub/ServiceRequestForm';
import ServiceRequestView from '../components/pages/service-hub/ServiceRequestView';
import ServiceRequestSchedule from '../components/pages/service-hub/ServiceRequestSchedule';
import ServiceRequestAssessment from '../components/pages/service-hub/ServiceRequestAssessment';
import ServiceRequestAcceptance from '../components/pages/service-hub/ServiceRequestAcceptance';
import ServiceRequestPrintView from '../components/pages/service-hub/ServiceRequestPrintView';
import ReportServiceHub from '../components/pages/service-hub/ReportServiceHub';
import ServiceRequestPrintAcceptanceView from '../components/pages/service-hub/ServiceRequestPrintAcceptanceView';
import ServiceRequestSOAPrintView from '../components/pages/service-hub/ServiceRequestSOAPrintView';
import CustomerMapDashboard from '../components/pages/dashboard/CustomerMapDashboard';
import PolarCareDashboard from '../components/pages/dashboard/PolarCareDashboard';
import EmployeesList from '../components/app/hr/EmployeesList';
import RolesList from '../components/pages/roles/RolesList';
import RolesForm from '../components/pages/roles/RolesForm';
import UsersList from '../components/pages/users/UsersList';
import UsersForm from '../components/pages/users/UsersForm';

import HomePage from '../components/pages/HomePage';

/** 
 * Cash Flwo Module
 * */
import CashFlowDashboard from '../components/app/cashflow/CashFlowDashboard';
import CashFlowTransactionsList from '../components/app/cashflow/CashFlowTransactionsList';

import ProtectedRoute from './ProtectedRoutes';
import ReportSalesItem from '../components/pages/reports/ReportSalesItem';
import GenerateQR from '../components/pages/tools/GenerateQR';
import GenerateQRPrintView from '../components/pages/tools/GenerateQRPrintView';
import ShipsList from '../components/pages/ship-booking/ships/ShipsList';
import VehiclesList from '../components/pages/ship-booking/vehicles/VehiclesList';
import MasterSchedulesList from '../components/pages/ship-booking/master-schedules/MasterSchedulesList';
import BookingList from '../components/pages/ship-booking/booking/BookingList';
import BookingNewForm from '../components/pages/ship-booking/booking/BookingNewForm';
import BookingViewForm from '../components/pages/ship-booking/booking/BookingViewForm';
import SchedulesList from '../components/pages/ship-booking/schedules/SchedulesList';
import SchedulesManifestPrintView from '../components/pages/ship-booking/schedules/SchedulesManifestPrintView';
import BookingSOAPrintView from '../components/pages/ship-booking/booking/BookingSOAPrintView';
import PortsList from '../components/pages/ship-booking/ports/PortsList';
import ScheduleView from '../components/pages/ship-booking/schedules/ScheduleView';
import BookingPrintView from '../components/pages/ship-booking/booking/BookingPrintView';
import PermissionsList from '../components/pages/permissions/PermissionsList';
import BoardingList from '../components/pages/ship-booking/boarding/BoardingList';
import CustomerSOAPrintView from '../components/pages/customer/CustomerSOAPrintView';
import QuotationList from '../components/pages/quotations/QuotationList';
import QuotationForm from '../components/pages/quotations/QuotationForm';
import QuotationView from '../components/pages/quotations/QuotationView';
import QuotationPrintView from '../components/pages/quotations/QuotationPrintView';

function MainRoutes(){
    const {
        account
    } = useContext(ProfileContext);

    return (
        <Routes>
            <Route 
                exact path="/"
                element={
                    <ProtectedRoute account={account}>
                        <Navigate replace to="/dashboard" />
                    </ProtectedRoute>
                }
            />

            <Route 
                exact path="/login" 
                element={<LoginPage />} 
            />

            <Route 
                exact path="account/profile" 
                element={
                    <ProtectedRoute account={account}>
                        <ProfilePage />
                    </ProtectedRoute>
                }
            />

            {/* USERS */}
            <Route 
                exact path="account/users/manage" 
                element={
                    <ProtectedRoute account={account} requiredPermissions={["superAdmin", "userView", "userCreate", "userEdit", "userDelete"]}>
                        <UsersList />
                    </ProtectedRoute>
                }
            />

            <Route 
                exact path="account/users/new" 
                element={
                    <ProtectedRoute account={account} requiredPermissions={["superAdmin", "userCreate"]}>
                        <UsersForm />
                    </ProtectedRoute>
                }
            />

            <Route 
                exact path="account/users/:user_id/edit" 
                element={
                    <ProtectedRoute account={account} requiredPermissions={["superAdmin", "userEdit"]}>
                        <UsersForm />
                    </ProtectedRoute>
                }
            />

            {/* ROLES */}
            <Route 
                exact path="account/roles/manage" 
                element={
                    <ProtectedRoute account={account} requiredPermissions={["superAdmin", "roleView", "roleCreate", "roleEdit", "roleDelete"]}>
                        <RolesList />
                    </ProtectedRoute>
                }
            />

            <Route 
                exact path="account/roles/new" 
                element={
                    <ProtectedRoute account={account} requiredPermissions={["superAdmin", "roleCreate"]}>
                        <RolesForm />
                    </ProtectedRoute>
                }
            />

            <Route 
                exact path="account/roles/:role_id/edit" 
                element={
                    <ProtectedRoute account={account} requiredPermissions={["superAdmin", "roleEdit"]}>
                        <RolesForm />
                    </ProtectedRoute>
                }
            />

            {/* PERMISSIONS */}
            <Route 
                exact path="account/permissions" 
                element={
                    <ProtectedRoute account={account} requiredPermissions={["superAdmin", "permissionView", "permissionCreate", "permissionEdit", "permissionDelete"]}>
                        <PermissionsList />
                    </ProtectedRoute>
                }
            />

            {/* <Route path="/inventory"> */}
                    <Route 
                        exact path="/dashboard"
                        element={
                            <ProtectedRoute account={account}>
                                <HomePage />
                            </ProtectedRoute>
                        }
                    />
                    <Route 
                        exact path="/customer-map"
                        element={
                            <ProtectedRoute account={account}>
                                <CustomerMapDashboard />
                            </ProtectedRoute>
                        }
                    />

                    {/* STORE MANAGEMENT */}
                    <Route path="store">
                        <Route 
                            exact path="profile"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "storeAdmin","storeView","storeEdit"]}>
                                    <StoreProfilePage />
                                </ProtectedRoute>
                            }
                        />
                        <Route 
                            exact path="delivery-address"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "storeAdmin","storeView","storeEdit"]}>
                                    <StoreDeliveryAddressPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route 
                            exact path="warehouses"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "storeAdmin","storeView","storeEdit"]}>
                                    <StoreWarehousesPage />
                                </ProtectedRoute>
                            }
                        />
                        {/* <Route 
                            exact path="store"
                            element={
                                <ProtectedRoute account={account}>
                                    <UnderConstructionPage module="Store Management" />
                                </ProtectedRoute>
                            }
                        /> */}
                    </Route>
                    
                    {/* PRODUCTS */}
                    <Route 
                        exact path="item/list"
                        element={
                            <ProtectedRoute account={account} requiredPermissions={["superAdmin", "inventoryView", "inventoryDelete"]}>
                                <ProductList />
                            </ProtectedRoute>
                        }
                    />
                    
                    <Route 
                        exact path="item/:product_id/edit"
                        element={
                            <ProtectedRoute account={account} requiredPermissions={["superAdmin", "inventoryEdit"]}>
                                <ProductForm />
                            </ProtectedRoute>
                        }
                    />
                    
                    <Route 
                        exact path="item/form"
                        element={
                            <ProtectedRoute account={account} requiredPermissions={["superAdmin", "inventoryCreate"]}>
                                <ProductForm />
                            </ProtectedRoute>
                        }
                    />
                        
                    <Route 
                        exact path="inventory-adjustment"
                        element={
                            <ProtectedRoute account={account} requiredPermissions={["superAdmin", "inventoryAdjustView", "inventoryAdjustDelete"]}>
                                <InventoryAdjustmentList />
                            </ProtectedRoute>
                        }
                    />
                        
                    <Route 
                        exact path="inventory-adjustment/:adjustment_id/edit"
                        element={
                            <ProtectedRoute account={account} requiredPermissions={["superAdmin", "inventoryAdjustEdit"]}>
                                <InventoryAdjustmentForm />
                            </ProtectedRoute>
                        }
                    />
                    
                    <Route 
                        exact path="inventory-adjustment/form"
                        element={
                            <ProtectedRoute account={account} requiredPermissions={["superAdmin", "inventoryAdjustCreate"]}>
                                <InventoryAdjustmentForm />
                            </ProtectedRoute>
                        }
                    />
                    
                    <Route 
                        exact path="settings/brands"
                        element={
                            <ProtectedRoute account={account} requiredPermissions={["superAdmin", "brandView", "brandCreate", "brandEdit", "brandDelete"]}>
                                <BrandsList />
                            </ProtectedRoute>
                        }
                    />
                
                    <Route 
                        exact path="settings/variant-types"
                        element={
                            <ProtectedRoute account={account} requiredPermissions={["superAdmin", "variantTypeView", "variantTypeCreate", "variantTypeEdit", "variantTypeDelete"]}>
                                <VariantTypesList />
                            </ProtectedRoute>
                        }
                    />
                
                    <Route 
                        exact path="settings/categories"
                        element={
                            <ProtectedRoute account={account} requiredPermissions={["superAdmin", "categoryView", "categoryCreate", "categoryEdit", "categoryDelete"]}>
                                <CategoryList />
                            </ProtectedRoute>
                        }
                    />

                    {/* QUOTATIONS */}
                        <Route 
                            exact path="quotations/list"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "quotationView", "quotationCreate", "salesOrderEdit", "salesOrderDelete", "salesOrderCancel", "salesOrderReport"]}>
                                    <QuotationList />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="quotations/new"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "quotationCreate"]}>
                                    <QuotationForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route  //View
                            exact path="quotations/:quotation_id"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "quotationView"]}>
                                    <QuotationView />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="quotations/:quotation_id/edit"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "quotationEdit"]}>
                                    <QuotationForm />
                                </ProtectedRoute>
                            }
                        />

                        <Route // Print View
                            exact path="quotations/:quotation_id/print"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "salesOrderView"]}>
                                    <QuotationPrintView />
                                </ProtectedRoute>
                            }
                        />

                    {/* SALES ORDER */}
                    {/* <Route path="sales"> */}
                        <Route 
                            exact path="sales/list"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "salesOrderView", "salesOrderCreate", "salesOrderEdit", "salesOrderDelete", "salesOrderCancel", "salesOrderReport"]}>
                                    <SalesOrderList />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="sales/form"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "salesOrderCreate"]}>
                                    <SalesOrderForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route  //View
                            exact path="sales/:order_id"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "salesOrderView"]}>
                                    <SalesOrderView />
                                </ProtectedRoute>
                            }
                        />

                        <Route // Print View
                            exact path="sales/:order_id/print"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "salesOrderView"]}>
                                    <SalesOrderPrintView />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="sales/:order_id/edit"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "salesOrderEdit"]}>
                                    <SalesOrderForm />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="sales/:order_id/sales-return"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "salesOrderView","salesReturnView","salesReturnCreate","salesReturnEdit"]}>
                                    <SalesReturnForm />
                                </ProtectedRoute>
                            }
                        />
                    {/* </Route> */}

                    {/* Invoices */}
                    {/* <Route path="invoices"> */}
                        <Route 
                            exact path="invoices/list"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "invoiceView","invoiceCreate","invoiceEdit","invoiceDelete","invoiceCancel"]}>
                                    <InvoicesList />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="invoices/form"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "invoiceCreate"]}>
                                    <InvoiceForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="invoices/:invoice_id/edit"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "invoiceEdit"]}>
                                    <InvoiceForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        {/* <Route 
                            exact path="invoices/:invoice_id/form"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "invoiceEdit"]}>
                                    <InvoiceForm />
                                </ProtectedRoute>
                            }
                        /> */}
                        
                        <Route 
                            exact path="invoices/:invoice_id/payment"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","paymentReceiveCreate","paymentReceiveEdit"]}>
                                    <PaymentReceiveForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route  //View
                            exact path="invoices/:invoice_id"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "invoiceView","invoiceCreate","invoiceDelete","invoiceCancel"]}>
                                    <InvoiceView />
                                </ProtectedRoute>
                            }
                        />

                        <Route // Print View
                            exact path="invoices/:invoice_id/print"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "invoiceView"]}>
                                    <InvoicePrintView />
                                </ProtectedRoute>
                            }
                        />
                    {/* </Route> */}

                    {/* Payment Receives */}
                    {/* <Route path="payment-receives"> */}
                        <Route 
                            exact path="payment-receives/list"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "paymentReceiveView","paymentReceiveCreate","paymentReceiveEdit","paymentReceiveDelete"]}>
                                    <PaymentReceiveList />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="payment-receives/new"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "paymentReceiveCreate"]}>
                                    <PaymentReceiveForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="payment-receives/:payment_receive_id/form"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "paymentReceiveEdit"]}>
                                    <PaymentReceiveForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="payment-receives/:payment_receive_id/edit"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "paymentReceiveEdit"]}>
                                    <PaymentReceiveForm />
                                </ProtectedRoute>
                            }
                        />
                    {/* </Route> */}

                    {/* Shipments */}
                    {/* <Route path="shipments"> */}
                        <Route 
                            exact path="shipments/list"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "shipmentView","shipmentCreate","shipmentEdit","shipmentDelete"]}>
                                    <ShipmentsList />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="shipments/:shipment_id/form"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "shipmentEdit"]}>
                                    <ShipmentForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="shipments/form"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "shipmentCreate"]}>
                                    <ShipmentForm />
                                </ProtectedRoute>
                            }
                        />
                    {/* </Route> */}

                    {/* Sales Returns */}
                    {/* <Route path="sales-returns"> */}
                        <Route 
                            exact path="sales-returns/list"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "salesReturnView","salesReturnCreate","salesReturnEdit","salesReturnDelete"]}>
                                    <SalesReturnList />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="sales-returns/:sales_return_id/form"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "salesReturnCreate","salesReturnEdit"]}>
                                    <SalesReturnForm />
                                </ProtectedRoute>
                            }
                        />
                    {/* </Route> */}

                    {/* Customers */}
                    {/* <Route path="customers"> */}
                        <Route 
                            exact path="customers/list"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "customerCreate","customerEdit", "customerDelete"]}>
                                    <ContactList />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="customers/:contact_id/edit"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","customerEdit"]}>
                                    <ContactForm />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="customers/:contact_id/print-soa"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "customerView"]}>
                                    <CustomerSOAPrintView />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="customers/:contact_id/product-units"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "productUnitView"]}>
                                    <ProductUnitList home_page='contact' />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="customers/:contact_id/product-units/:product_unit_id/form"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","productUnitView"]}>
                                    <ProductUnitForm />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="customers/:contact_id/vehicles"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "vehiclesView"]}>
                                    <VehiclesList home_page='contact' />
                                </ProtectedRoute>
                            }
                        />
                    
                        <Route 
                            exact path="customers/form"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "customerCreate"]}>
                                    <ContactForm />
                                </ProtectedRoute>
                            }
                        />
                    {/* </Route> */}
                    
                    {/* Couriers */}
                    <Route 
                        exact path="settings/couriers"
                        element={
                            <ProtectedRoute account={account} requiredPermissions={["superAdmin", "courierCreate","courierEdit", "courierDelete"]}>
                                <CouriersList />
                            </ProtectedRoute>
                        }
                    />

                    {/* PURCHASE ORDER */}
                    {/* <Route path="purchases"> */}
                        <Route 
                            exact path="purchases/list"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "purchaseOrderView", "purchaseOrderCreate", "purchaseOrderEdit", "purchaseOrderDelete", "purchaseOrderCancel"]}>
                                    <PurchaseOrderList />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="purchases/new"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "purchaseOrderCreate"]}>
                                    <PurchaseOrderForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="purchases/:order_id"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "purchaseOrderView"]}>
                                    <PurchaseOrderView />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="purchases/:order_id/edit"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "purchaseOrderEdit"]}>
                                    <PurchaseOrderForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="purchases/:order_id/print"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "purchaseOrderView"]}>
                                    <PurchaseOrderPrintView />
                                </ProtectedRoute>
                            }
                        />
                        
                        {/* <Route 
                            exact path="purchases/form-v1"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "purchaseOrderCreate"]}>
                                    <PurchaseOrderFormV1 />
                                </ProtectedRoute>
                            }
                        /> */}
                    {/* </Route> */}
                    
                    {/* BILL */}
                    {/* <Route path="bills"> */}
                        <Route 
                            exact path="bills/list"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","billView","billCreate","billEdit","billDelete","billCancel"]}>
                                    <BillsList />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="bills/new"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","billCreate"]}>
                                    <BillForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="bills/:bill_id/edit"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","billEdit"]}>
                                    <BillForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="bills/:bill_id/form"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","billEdit"]}>
                                    <BillForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        {/* Payment made from bills */}
                        <Route 
                            exact path="bills/:bill_id/payment"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","paymentMadeCreate","paymentMadeEdit"]}>
                                    <PaymentMadeForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route  //View
                            exact path="bills/:bill_id"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","billView"]}>
                                    <BillView />
                                </ProtectedRoute>
                            }
                        />

                        <Route // Print View
                            exact path="bills/:bill_id/print"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","billView"]}>
                                    <BillPrintView />
                                </ProtectedRoute>
                            }
                        />
                    {/* </Route> */}

                    {/* PAYMENT MADE */}
                    {/* <Route path="payment-made"> */}
                        <Route 
                            exact path="payment-made/list"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","paymentMadeView","paymentMadeCreate","paymentMadeEdit","paymentMadeDelete"]}>
                                    <PaymentMadeList />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="payment-made/new"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","paymentMadeCreate"]}>
                                    <PaymentMadeForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="payment-made/:payment_made_id/edit"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","paymentMadeEdit"]}>
                                    <PaymentMadeForm />
                                </ProtectedRoute>
                            }
                        />
                    {/* </Route> */}

                    
                    {/* PURCHASE RECEIVES */}
                    {/* <Route path="purchase-receives"> */}
                        <Route 
                            exact path="purchase-receives/list"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","purchaseReceiveView","purchaseReceiveCreate","purchaseReceiveEdit","purchaseReceiveDelete"]}>
                                    <PurchaseReceivesList />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="purchase-receives/:receive_id/edit"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","purchaseReceiveEdit"]}>
                                    <PurchaseReceiveForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="purchase-receives/new"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","purchaseReceiveCreate"]}>
                                    <PurchaseReceiveForm />
                                </ProtectedRoute>
                            }
                        />
                    {/* </Route> */}

                    {/* VENDORS */}
                    {/* <Route path="vendors"> */}
                        <Route 
                            exact path="vendors/list"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","vendorView","vendorCreate","vendorEdit","vendorDelete"]}>
                                    <VendorsList />
                                </ProtectedRoute>
                            }
                        />
                    
                        <Route 
                            exact path="vendors/form"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","vendorCreate"]}>
                                    <VendorsForm />
                                </ProtectedRoute>
                            }
                        />
                        
                        <Route 
                            exact path="vendors/:vendor_id/edit"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","vendorEdit"]}>
                                    <VendorsForm />
                                </ProtectedRoute>
                            }
                        />
                    {/* </Route> */}

                    {/* Reports */}
                    <Route 
                        exact path="reports"
                        element={
                            <ProtectedRoute account={account} requiredPermissions={["superAdmin", "inventoryReport", "salesOrderReport", "invoiceReport", "paymentReceiveReport","customerReport", "shipmentReport", "purchaseOrderReport","billReport","purchaseReceiveReport", "vendorReport", "paymentMadeReport","courierReport","serviceHubReport"]}>
                                <ReportListPage />
                            </ProtectedRoute>
                        }
                    />
                    
                    <Route path="reports">
                        <Route 
                            exact path="item"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","inventoryReport"]}>
                                    <ReportInventory />
                                </ProtectedRoute>
                            }
                        />
                        <Route 
                            exact path="sales"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","salesOrderReport"]}>
                                    <ReportSalesOrder />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="sales/pending-deliveries"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","salesOrderReport"]}>
                                    <ReportSalesItem filtered_by='pending-delivery' />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="sales-return"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","salesOrderReport"]}>
                                    <ReportSalesReturn />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="invoices"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","invoiceReport"]}>
                                    <ReportInvoices />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="invoices/top-items"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","salesOrderReport","invoiceReport"]}>
                                    <ReportInvoiceItem filtered_by='top-items' />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="payments/received"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","paymentReceiveReport"]}>
                                    <ReportPaymentReceived />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="bills"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","billReport"]}>
                                    <ReportBills />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="payments/made"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "paymentMadeReport"]}>
                                    <ReportPaymentMade />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="purchases"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "purchaseOrderReport"]}>
                                    <ReportPurchasesOrder />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="purchases/top-items"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "purchaseOrderReport"]}>
                                    <ReportPurchasesItem filtered_by='top-items' />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="purchases/receivables"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "purchaseOrderReport"]}>
                                    <ReportPurchasesItem filtered_by='receivables' />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="customers"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "customerReport"]}>
                                    <ReportContacts />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="vendors"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "vendorReport"]}>
                                    <ReportVendors />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="service-requests"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "serviceHubReport"]}>
                                    <ReportServiceHub />
                                </ProtectedRoute>
                            }
                        />
                    
                    </Route>
                    {/* End of Reports */}

                    <Route 
                        exact path="settings" 
                        element={
                            <ProtectedRoute account={account}>
                                <PageSettings />
                            </ProtectedRoute>
                        }
                    />

                    <Route path="settings">
                        <Route 
                            exact path="tax-rates"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "taxRateView", "taxRateCreate", "taxRateEdit", "taxRateDelete"]}>
                                    <TaxRatesList />
                                </ProtectedRoute>
                            }
                        />
                    </Route>

                    <Route path="settings">
                        <Route 
                            exact path="discount-rates"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "discountRateView", "discountRateCreate", "discountRateEdit", "discountRateDelete"]}>
                                    <DiscountRatesList />
                                </ProtectedRoute>
                            }
                        />
                    </Route>

                    {/* Tools */}
                    <Route path="tools">
                        <Route 
                            exact path="qr-range-generator"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "QRCodeRangeGenerator"]}>
                                    <GenerateQR />
                                </ProtectedRoute>
                            }
                        />
                        <Route 
                            exact path="qr-range-generator-print"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin", "QRCodeRangeGenerator"]}>
                                    <GenerateQRPrintView />
                                </ProtectedRoute>
                            }
                        />
                    </Route>

                    {/* Ship Booking Module */}
                    
                    <Route path="ship-booking">
                        <Route 
                            exact path="ships"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","shipView","shipCreate","shipEdit","shipDelete"]}>
                                    <ShipsList />
                                </ProtectedRoute>
                            }
                        />
                        <Route 
                            exact path="ports"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","portView","portCreate","portEdit","portDelete"]}>
                                    <PortsList />
                                </ProtectedRoute>
                            }
                        />
                        <Route 
                            exact path="vehicles"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","vehicleView","vehicleCreate","vehicleEdit","vehicleDelete"]}>
                                    <VehiclesList />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="master-schedules"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","masterScheduleView","masterScheduleCreate","masterScheduleEdit","masterScheduleDelete"]}>
                                    <MasterSchedulesList />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="schedules"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","voyageScheduleView","voyageScheduleCreate", "voyageScheduleEdit","voyageScheduleDelete"]}>
                                    <SchedulesList />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="schedules/:schedule_id/manifest"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","voyageScheduleView","voyageScheduleCreate", "voyageScheduleEdit","voyageScheduleDelete"]}>
                                    <ScheduleView />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="schedules/:schedule_id/manifest-print"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","voyageScheduleView"]}>
                                    <SchedulesManifestPrintView />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="bookings"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","shipBookingView","shipBookingDelete"]}>
                                    <BookingList />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="bookings/new"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","shipBookingCreate"]}>
                                    <BookingNewForm />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="bookings/:booking_id"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","shipBookingView","shipBookingEdit","shipBookingDelete"]}>
                                    <BookingViewForm />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="bookings/:booking_id/print-view"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","shipBookingView"]}>
                                    <BookingPrintView />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="print-soa"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","shipBookingView","customerView","customerCreate","customerEdit"]}>
                                    <BookingSOAPrintView />
                                </ProtectedRoute>
                            }
                        />

                        <Route 
                            exact path="boarding"
                            element={
                                <ProtectedRoute account={account} requiredPermissions={["superAdmin","shipOnBoarding"]}>
                                    <BoardingList />
                                </ProtectedRoute>
                            }
                        />
                    </Route>

                
                    <Route 
                        exact path="settings/categories"
                        element={
                            <ProtectedRoute account={account} requiredPermissions={["superAdmin", "categoryView", "categoryCreate", "categoryEdit", "categoryDelete"]}>
                                <CategoryList />
                            </ProtectedRoute>
                        }
                    />

                    {/* Accounting Module */}
                    {/* <Route 
                        exact path="chart-of-accounts"
                        element={
                            <ProtectedRoute account={account} requiredPermissions={["superAdmin", "service-request-create"]}>
                                <ChartOfAccountsList />
                            </ProtectedRoute>
                        }
                    />
                    <Route 
                        exact path="journals"
                        element={
                            <ProtectedRoute account={account} requiredPermissions={["superAdmin", "service-request-create"]}>
                                <JournalsList />
                            </ProtectedRoute>
                        }
                    /> */}
            {/* </Route> */}

            <Route 
                exact path="/app"
                element={
                    <ProtectedRoute account={account}>
                        <Navigate replace to="/dashboard" />
                    </ProtectedRoute>
                }
            />

            {/* ServiceHub */}
            {/* Service Request */}
            <Route exact path="/service-requests/list"
                element={
                    <ProtectedRoute account={account} requiredPermissions={["superAdmin", "serviceHubView","serviceHubCreate","serviceHubEdit","serviceHubDelete","serviceHubSchedule","serviceHubAssess","serviceHubAccept"]}>
                        <ServiceRequestList />
                    </ProtectedRoute>
                }
            />

            <Route exact path="/service-requests/schedule"
                element={
                    <ProtectedRoute account={account} requiredPermissions={["superAdmin", "serviceHubViewAssgined"]}>
                        <ServiceRequestList view='assigned' menu="manage-service-schedule" page_title="Service Request Schedules" />
                    </ProtectedRoute>
                }
            />

            <Route exact path="/service-requests/schedule/:service_request_id"
                element={
                    <ProtectedRoute account={account} requiredPermissions={["superAdmin", "serviceHubViewAssgined"]}>
                        <ServiceRequestView view='assigned' menu="manage-service-schedule" />
                    </ProtectedRoute>
                }
            />

            <Route exact path="/service-requests/new"
                element={
                    <ProtectedRoute account={account} requiredPermissions={["superAdmin", "serviceHubCreate"]}>
                        <ServiceRequestForm />
                    </ProtectedRoute>
                }
            />

            <Route exact path="/service-requests/print-soa"
                element={
                    <ProtectedRoute account={account} requiredPermissions={["superAdmin", "serviceHubView","serviceHubViewAssgined"]}>
                        <ServiceRequestSOAPrintView />
                    </ProtectedRoute>
                }
            />

            <Route exact path="/service-requests/:service_request_id/form"
                element={
                    <ProtectedRoute account={account} requiredPermissions={["superAdmin", "serviceHubEdit"]}>
                        <ServiceRequestForm />
                    </ProtectedRoute>
                }
            />

            <Route exact path="/service-requests/:service_request_id/schedule"
                element={
                    <ProtectedRoute account={account} requiredPermissions={["superAdmin", "serviceHubSchedule"]}>
                        <ServiceRequestSchedule />
                    </ProtectedRoute>
                }
            />

            <Route exact path="/service-requests/:service_request_id/acceptance"
                element={
                    <ProtectedRoute account={account} requiredPermissions={["superAdmin", "serviceHubAccept"]}>
                        <ServiceRequestAcceptance />
                    </ProtectedRoute>
                }
            />

            <Route exact path="/service-requests/:service_request_id/assessment"
                element={
                    <ProtectedRoute account={account} requiredPermissions={["superAdmin", "serviceHubAssess"]}>
                        <ServiceRequestAssessment />
                    </ProtectedRoute>
                }
            />

            <Route exact path="/service-requests/:service_request_id"
                element={
                    <ProtectedRoute account={account} requiredPermissions={["superAdmin", "serviceHubView", "serviceHubViewAssgined"]}>
                        <ServiceRequestView />
                    </ProtectedRoute>
                }
            />

            <Route exact path="/service-requests/:service_request_id/print"
                element={
                    <ProtectedRoute account={account} requiredPermissions={["superAdmin", "serviceHubView", "serviceHubViewAssgined"]}>
                        <ServiceRequestPrintView />
                    </ProtectedRoute>
                }
            />

            <Route exact path="/service-requests/:service_request_id/print-acceptance"
                element={
                    <ProtectedRoute account={account} requiredPermissions={["superAdmin", "serviceHubView", "serviceHubViewAssgined"]}>
                        <ServiceRequestPrintAcceptanceView />
                    </ProtectedRoute>
                }
            />

            {/* Product Units */}
            <Route exact path="/product-units/list"
                element={
                    <ProtectedRoute account={account} requiredPermissions={["superAdmin", "productUnitView","productUnitCreate","productUnitEdit","productUnitDelete"]}>
                        <ProductUnitList home_page='product-units' />
                    </ProtectedRoute>
                }
            />

            <Route exact path="/product-units/new"
                element={
                    <ProtectedRoute account={account} requiredPermissions={["superAdmin", "productUnitCreate"]}>
                        <ProductUnitForm />
                    </ProtectedRoute>
                }
            />

            <Route exact path="/product-units/qr/:qr_code"
                element={
                    <ProductUnitForm />
                }
            />

            <Route exact path="/product-units/:product_unit_id/form"
                element={
                    <ProtectedRoute account={account} requiredPermissions={["superAdmin", "productUnitView", "productUnitEdit"]}>
                        <ProductUnitForm />
                    </ProtectedRoute>
                }
            />

            {/* Human Resources Management System */}
            <Route path="hrms">
                <Route path="employees">
                    <Route 
                        exact path="list"
                        element={
                            <ProtectedRoute account={account} requiredPermissions={["superAdmin", "employeeView", "employeeCreate", "employeeEdit", "employeeDelete"]}>
                                <EmployeesList />
                            </ProtectedRoute>
                        }
                    />
                </Route>
            </Route>

            {/* Cash Flow */}
            <Route 
                exact path="cashflow"
                element={
                    <ProtectedRoute account={account} requiredPermissions={["superAdmin"]}>
                        <CashFlowDashboard />
                    </ProtectedRoute>
                }
            />

            <Route 
                exact path="cashflow/transactions"
                element={
                    <ProtectedRoute account={account} requiredPermissions={["superAdmin","cashFlowTransactionView","cashFlowTransactionCreate","cashFlowCTransactionEdit","cashFlowTransactionDelete"]}>
                        <CashFlowTransactionsList />
                    </ProtectedRoute>
                }
            />
            
            {/* Apps Module */}
            <Route path="app/savers">
                <Route path=":group_id">
                    <Route 
                        exact path="dashboard"
                        element={
                            <ProtectedRoute account={account} requiredPermissions={["superAdmin"]}>
                                <HomePageSavers />
                            </ProtectedRoute>
                        }
                    />
                    <Route 
                        exact path="info"
                        element={
                            <ProtectedRoute account={account} requiredPermissions={["superAdmin"]}>
                                <GroupForm />
                            </ProtectedRoute>
                        }
                    />
                    <Route 
                        exact path="shares"
                        element={
                            <ProtectedRoute account={account} requiredPermissions={["superAdmin"]}>
                                <SharesList />
                            </ProtectedRoute>
                        }
                    />
                    <Route 
                        exact path="shares/new"
                        element={
                            <ProtectedRoute account={account} requiredPermissions={["superAdmin"]}>
                                <SharesForm />
                            </ProtectedRoute>
                        }
                    />
                    <Route 
                        exact path="shares/:share_id"
                        element={
                            <ProtectedRoute account={account} requiredPermissions={["superAdmin"]}>
                                <SharesForm />
                            </ProtectedRoute>
                        }
                    />
                </Route>

                <Route 
                    exact path="group/new"
                    element={
                        <ProtectedRoute account={account} requiredPermissions={["superAdmin"]}>
                            <SharesList />
                        </ProtectedRoute>
                    }
                />
            </Route>

            {/* Savers App */}
            <Route 
                exact path="/template"
                element={
                    <ProtectedRoute account={account}>
                        <StarterTemplate />
                    </ProtectedRoute>
                }
            />

            {/* 
            <Route 
                exact path="/production" 
                element={<UnderConstructionPage module="Production Management System" />} 
            />
            */}

            <Route 
                path="*" 
                element={<Page404 />} 
            />
        </Routes>
    )
}

export default MainRoutes;
